import { render, staticRenderFns } from "./ShowShortCode.vue?vue&type=template&id=59b63c3c&scoped=true"
import script from "./ShowShortCode.vue?vue&type=script&lang=js"
export * from "./ShowShortCode.vue?vue&type=script&lang=js"
import style0 from "./ShowShortCode.vue?vue&type=style&index=0&id=59b63c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b63c3c",
  null
  
)

export default component.exports